module.exports = __webpack_public_path__ + "img/nature-5.fc9d1c91.jpg";